import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Classificazione} from "../../../../../../../common/models/classificazione";
import {CreazionePraticaStoreService} from "../../../../services/creazione-pratica-store.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import { ThemeService } from "ng2-charts";


@Component({
  selector: 'app-classificazioni',
  templateUrl: './classificazioni.component.html',
  styleUrls: ['./classificazioni.component.css']
})
export class ClassificazioniComponent implements OnInit {

  @Input() classificazioni: Classificazione[];
  @Output() classificazioneEmitter: EventEmitter<Classificazione> = new EventEmitter<Classificazione>();
  @Output() classificazioneRemover: EventEmitter<Classificazione> = new EventEmitter<Classificazione>();
  @Input() hasPrincipale: boolean;

  constructor(private creazionePraticaStoreService: CreazionePraticaStoreService) {

  }

  ngOnInit() {
    /*this.classificazioni = this.creazionePraticaStoreService.classificazioni$.pipe(
      map(el => !el ? [] : el)
      );
    this.creazionePraticaStoreService.checkClassificazioni().subscribe(el =>
      this.listContainsIsPrincipale = el);*/
  }

  addClassificazione(classificazione: Classificazione){
    //this.creazionePraticaStoreService.addClassificazioni(classificazione);
    this.classificazioneEmitter.emit(classificazione);
  }

  removeClassificazione(classificazione: Classificazione){
    this.classificazioneRemover.emit(classificazione);
  }

}
